import { __read } from "tslib";
import { useState, useCallback } from 'react';
export default function useBoolean(initial) {
    var _a = __read(useState(initial), 2), value = _a[0], setValue = _a[1];
    return {
        value: value,
        setValue: setValue,
        toggle: useCallback(function () { return setValue(function (v) { return !v; }); }, []),
        setTrue: useCallback(function () { return setValue(true); }, []),
        setFalse: useCallback(function () { return setValue(false); }, []),
    };
}
